<div class="container">
  <ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
    [spinner]="spinkit.skThreeBounce">
  </ng-http-loader>
  <div class="row row-class main_header">
    <div *ngIf="UserCondition" class="col-8">
      <span class="guests">Hi {{userName}} ! &nbsp;
        <a class="icofont-ui-home " style="color: red !important;" (click)="backHomeUser()"></a>
      </span>
    </div>
    <div *ngIf="!UserCondition" class="col-8">
      <span class="guests">Hi Guest ! &nbsp;
        <a class="icofont-ui-home " style="color: red !important;" (click)="backHomeGuest()"></a>
      </span>
    </div>
    <div *ngIf="UserCondition" class="col-4 back" (click)="logout()">
      <span class="icon icofont-logout"></span>
      Logout
    </div>
  </div>
  <div class="row" style="padding-top: 5px;">
    <div class="col-6">
      <span class="titles">Profile &nbsp;
        <i *ngIf="UserCondition"  class="fa fa-pencil-square-o" style="color: #47941b !important; font-size: 20px;"  tooltip="Click to view profile menu"  aria-hidden="true" (click)="OnEditclick()"></i>
      </span>
    </div>
  </div>

  <div *ngIf="UserCondition" class="row justify-content-center ">
    <div *ngFor="let userdatail of userdatails_array">
      <form novalidate class="mb-4">
        <div class="row">
          <div class="col-3 py-2">
            <tc-form-group>
              <tc-avatar *ngIf="!userdatail.up_profile_image" [src]="defalutimage" [size]="80"></tc-avatar>
              <label  for="fileInput">
                <tc-avatar *ngIf = "userdatail.up_profile_image" [src]="userdatail.up_profile_image" [size]="80" class="image"
                ></tc-avatar> 
              </label>
              <br/>
              <input id="fileInput" type='file' (change)="onImageChange($event)">
              <label  for="fileInput">
              <p class="text_photo" >Change photo</p>
            </label>
            </tc-form-group>
          </div>
          <div class="col-9" style="padding-left: 20px; margin-top: 4%;">
              <div class="row" style="margin-bottom: 10px;">
                <div class="col-12">       
                    <span class="username_text" >{{userdatail.up_fname}}
                      {{userdatail.up_lname}}</span> &nbsp;&nbsp;
                      <span *ngIf="userdatail.up_gender !='NA' &&  userdatail.up_gender == 'Man'">
                        <img class="img_gender"   [src]="male"  alt="notdis" width="14">              
                      </span>
                      <span  *ngIf="userdatail.up_gender !='NA' &&  userdatail.up_gender == 'Woman'">
                        <img class="img_gender"  [src]="female"   alt="notdis" width="14">              
                      </span>     
                </div>
              </div>
              <ui-switch size="small" [checked]=" userdatail.user_preference_cc == 'Yes' ? true : false" (change)="crossCon($event)"></ui-switch>
              <tc-form-label class="cross_text"> Avoid cross contamination</tc-form-label>
            <tc-form-group *ngIf="userdatail.user_preference_spice">
              <div class="row">
                <div class="col-4.5" style="margin-top: -4px;" >
                  <span *ngFor="let value of count(userdatail.user_preference_spice)">
                    <img src="./assets/img/mirchi.png" alt="spiceimage" width="18">
                  </span>
                </div>
                <div class="col-6.5" style="padding-left: 10px;">
                  <tc-form-label style=" font-size: 13px;color: #6f706e;font-weight: 600;">Spice tolerance
                  </tc-form-label>
                </div>  
              </div>
            </tc-form-group>
          </div>
        </div>
        <table style="width: 100%; margin-top: -5px; ">
          <tr align="center">
            <td style="width: 50%;">         
                 <p style=" font-size: 14px;color: #ff0000;font-weight: 600;">
                  Food Allergies/Intolerance
                 </p>         
            </td>
            <td style="width: 50%;" >
                <p style=" font-size: 14px;color: #47941b;font-weight: 600;">
                  Dietary preferences
                </p>    
            </td>
          </tr>
          <tr>
            <td align="center" >
              <tc-form-group *ngIf="!userdatail.userAllergens">
                <h6 style="font-weight: 600; color: #6f706e;">Not Available</h6>
              </tc-form-group>
                <tc-form-group *ngIf="userdatail.userAllergens">
                  <ng-container *ngFor="let allergies of userdatail.userAllergens ; index as i">
                    <div *ngIf="i< 2 ">
                      <button class="buttonsallergy" [title]="allergies.allergens_name"
                        [style.background-color]="'#ff0000'" [style.color]="'white'">
                        <span>{{allergies.allergens_name}}</span> </button>&nbsp;&nbsp;
                    </div>
                  </ng-container>
                </tc-form-group>
              <div class="More col-12 text-center " *ngIf="lengthallergens >2">
                <button class="moreTitle" (click)="onClickallergen()">More</button>
              </div>
            </td>
            <td align="center">
              <tc-form-group *ngIf="!userdatail.userDietary">
                <h6 style="font-weight: 600; color: #6f706e;">Not Available</h6>
              </tc-form-group>
                <tc-form-group *ngIf="userdatail.userDietary">
                  <ng-container *ngFor="let dietary of userdatail.userDietary; index as i">
                    <div *ngIf="i< 2 ">
                      <button class="buttonsdietary" [title]="dietary.diet_preference_name"
                        [style.background-color]="'#47941b'" [style.color]="'white'">{{dietary.diet_preference_name}}
                      </button>&nbsp;&nbsp;
                    </div>
                  </ng-container>
                </tc-form-group>
              <div class="More col-12 text-center " *ngIf="lengthdietary > 2">
                <button class="moreTitle" (click)="onClickdietary()">More</button>
              </div>
            </td>
          </tr>
        </table>
        <tc-form-group *ngIf="taste_code">
          <tc-form-label  style=" font-size: 14px;color: #6f706e;font-weight: 600;  margin-top: -10px;">Unique taste id
          </tc-form-label>
          <p class="text_bold"> Your unique taste ID has been created as </p>
          <p class="bold"><span style="line-height: 0.1;">{{taste_code}}</span></p>
          <p class="text_bold">You are similar to <span class="bold"> {{taste_totalScore}} %</span> Foodbud users.</p>
        </tc-form-group>
        <tc-form-group *ngIf="taste_code" align="center">
          <ng-container>
            <button class="buttonsgen" [routerLink]="['../', 'sharefriends']" [style.background-color]="'#47941b'"
              [style.color]="'white'">Share with friends </button>
          </ng-container>
        </tc-form-group>
        <tc-form-group *ngIf="!taste_code" align="center">
          <ng-container>
            <button class="buttonsgen" (click)="tasteidgenerate()" [style.background-color]="'#47941b'"
              [style.color]="'white'">Generate Taste Id </button>
          </ng-container>
        </tc-form-group>
        <div class="row options">
          <div class="col-12 col-sm-4" >
            <a [routerLink]="['../', 'edit-tasteprofile']" (click)="myDetails()">My details
              <span style="float: right;">
                <tc-icon [iconClass]="'icofont-rounded-right'" [tcFontSize]="25" [padding]="0"></tc-icon>
              </span>
            </a>
            <hr  style="width: 100%; color: black; margin-top: 10px;">
          </div>
          &nbsp;
                <div class="col-12 col-sm-4">
                  <a [routerLink]="['../', 'edit-tasteprofile']" (click)="mypreferences()" > My food Preferences
                    <span style="float: right;">
                      <tc-icon [iconClass]="'icofont-rounded-right'" [tcFontSize]="25" [padding]="0"></tc-icon>
                    </span>
                  </a>
                  <hr *ngIf="taste_code" style="width: 100%; color: black; margin-top: 10px;">
                </div>
          &nbsp;
          <div class="col-12 col-sm-4" *ngIf="taste_code" >
            <a [routerLink]="['../', 'edit-tasteprofile']" (click)="myfriend()">My friends
              <span style="float: right;">
                <tc-icon [iconClass]="'icofont-rounded-right'" [tcFontSize]="25" [padding]="0"></tc-icon>
              </span>
            </a>
            <hr style="width: 100%; color: black; margin-top: 10px;">
          </div>
          <div class="col-12 col-sm-4" *ngIf="taste_code">
            <a [routerLink]="['../', 'edit-tasteprofile']" (click)="sharefriends()">Share with your friends
              <span style="float: right;">
                <tc-icon [iconClass]="'icofont-rounded-right'" [tcFontSize]="25" [padding]="0"></tc-icon>
              </span>
            </a>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="row" *ngIf="!UserCondition" style="padding-top: 50%;justify-content: center;">
    <div class="col-10">
      <button tc-button (click)="backTologin()">Login to view the Profile</button> <br>
    </div>
  </div>
  <div class="row" *ngIf="!UserCondition" style=" padding-top:80px;justify-content: center;">
    <div><a [routerLink]="['../', 'food-menu-guest']">
        <span class="moreTitle">
          Back to menu
        </span> </a>
    </div>
  </div>
  <br>
  <br>
  <br>
  <br>
</div>
<app-bottommenu-resto></app-bottommenu-resto>

